<template>
  <section class="password-request">
    <div class="container">
      <div class="password-request__image"></div>
      <div class="password-request__form">
        <h2 v-text="$t('Reset Password')"></h2>
        <validation-observer
          v-slot="{ handleSubmit, invalid, validated }"
          ref="form"
          tag="div"
        >
          <form @submit.prevent="handleSubmit(submit)">
            <validation-provider
              v-slot="{ errors }"
              class="form-group"
              tag="div"
              rules="required|email"
              :name="$t('Email')"
              vid="email"
            >
              <label
                for="email"
                class="form-label"
                v-text="$t('Email')"
              ></label>
              <div
                class="form-validation"
                :class="{ 'is-invalid': errors.length }"
              >
                <input
                  id="email"
                  v-model="form.email"
                  type="text"
                  :placeholder="$t('john.pitterson@gmail.com')"
                  class="form-control form-input--underline"
                />
                <span v-if="errors.length" v-text="errors[0]"></span>
              </div>
            </validation-provider>
            <button
              class="btn btn--primary btn--send"
              :class="{ 'btn--disabled': (validated && invalid) || loading }"
              :disabled="loading"
            >
              {{ $t('Send link') }}
            </button>
          </form>
        </validation-observer>
      </div>
    </div>
    <modal v-show="showModal" @close="showModal = false">
      <h5 slot="title" class="mb-0">
        {{ $t('New password was sent to your email!') }}
      </h5>
      <div slot="content" class="modal__content">
        <div>
          <img src="@/assets/img/message_sent.svg" alt="Letter" />
        </div>
      </div>
    </modal>
  </section>
</template>

<i18n src="./translations.json"></i18n>

<script>
import auth from '@/api/auth';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Modal from '@/components/modal/Modal';

export default {
  components: {
    Modal,
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      form: {
        email: '',
      },
      loading: false,
      message: '',
      showModal: false,
    };
  },

  methods: {
    async submit() {
      this.loading = true;

      try {
        await auth.requestPassword(this.form.email);
        this.openModal();
      } catch (error) {
        this.$refs.form.setErrors({
          email: this.$t('Could not find email'),
        });
      }

      this.loading = false;
    },

    openModal() {
      this.showModal = true;
    },

    setStatusMessage(message) {
      this.message = message;
    },
  },
};
</script>

<style lang="scss">
@import './request.scss';
</style>
